export const SCHEDULE_ADDITIONAL_DATA_TYPE = {
    company: 'Company'
};